import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_RESULT_PATH_KEY } from '@/swagger/constants/quiz-keys';
import { API_GET_QUIZ_BY_ID_RESULT, KEY_GET_QUIZ_BY_ID_RESULT } from '../constats';
import { MOCK_RESPONSE_GET_QUIZ_BY_ID_RESULT } from '../mocks';

type GetQuizByIdResult = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_RESULT_PATH_KEY
>;

type RequestGetQuizByIdResult = GetQuizByIdResult['request']['path'];

type ResponseGetQuizByIdResult = GetQuizByIdResult['response']['body'];

type CallParamsGetQuizByIdResult = Omit<RequestGetQuizByIdResult, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetQuizByIdResult = ResponseGetQuizByIdResult;

type CallErrorGetQuizByIdResult = GenericApiError;

type CallSelectorsGetQuizByIdResult = {
  result: ResponseGetQuizByIdResult;
};

export const getQuizByIdResultCall = createGeneralCall<
  CallParamsGetQuizByIdResult,
  CallResponseGetQuizByIdResult,
  CallErrorGetQuizByIdResult,
  CallSelectorsGetQuizByIdResult
>({
  id: KEY_GET_QUIZ_BY_ID_RESULT,
  method: 'get',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_QUIZ_BY_ID_RESULT(org, payload.id);
    },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  // @ts-ignore
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_GET_QUIZ_BY_ID_RESULT
    : undefined,
  selectors: {
    result: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
});
